import { HelpfulHints } from '../common/HelpfulHints'
import s from '../HelpCenterModal.scss'

const MultipleBids = () => {
  return (
    <div className={s.container}>
      <div className={s.leftContainer}>
        <iframe
          width="500"
          height="315"
          src="https://www.youtube.com/embed/d8ahD53sI9I?start=79"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
        ></iframe>
        <h3 className={s.title}>Track Opportunities with Multiple Bids with iDeal CRM</h3>
        <div className={s.content}>
          Having to track multiple bids or clients for the same opportunity is a common occurrence
          in the construction industry. It’s that situation when you receive multiple ITBs for the
          same project from different clients and you will bid all these clients for this one
          project.
          <br />
          <br />
          The challenges you face:
          <ul className={s.styledList}>
            <li>Creating proposals for each client you received ITB from</li>
            <li>Sending your bids on time to each client</li>
            <li>Tracking the status of each </li>
            <li>Finding out which client is awarded the job</li>
            <li>
              Following-up with the awarded client so you can beat your own competition and win the
              job
            </li>
          </ul>
          That’s a lot of tracking and following up for each opportunity!
          <br />
          <br />
          Watch the video above or download{' '}
          <a
            href="https://ideal-help.s3.us-east-2.amazonaws.com/pdf/Track+Opportunities+with+Multiple+Bids+with+iDeal+CRM.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            {' '}
            Track Opportunities with Multiple Bids
          </a>{' '}
          for step-by-step instructions.
        </div>
      </div>
      <div className={s.rightContainer}>
        <HelpfulHints
          downloadLink="https://ideal-help.s3.us-east-2.amazonaws.com/pdf/Track+Opportunities+with+Multiple+Bids+with+iDeal+CRM.pdf"
          thumbnailUrl="https://ideal-help.s3.us-east-2.amazonaws.com/thumbnails/Track+Opportunities+with+Multiple+Bids+with+iDeal+CRM.jpg"
          text="Track Opportunities with Multiple Bids with iDeal CRM"
        />
      </div>
    </div>
  )
}

export default MultipleBids
